module.exports = __webpack_public_path__ + "media/checkout/Checout-Box-Thumbnail-5ccf0ec1.jpg";